export const ERROR_MESSAGE: { [key: string]: string } = {
  NETWORK: '인터넷 연결 확인 후, 다시 시도해 주세요.',
  SERVER: '서비스 중 문제가 발생했어요.\n잠시 후 다시 시도해 주세요.',
  TIMEOUT: '일시적으로 장애가 발생하였습니다.\n잠시 후에 다시 시도해 주세요.',
  LOGIN: '로그인에 실패했어요.\n다시 시도해 주세요.',
  // 아래 코드들은 아래 API 호출시 발생하는 에러에 해당됩니다.
  // {{myid}}credential/issue/mobile
  // {{user-api}}/reissue
  // {{user-api}}/refresh
  // {{user-api}}/verify
  // {{myid}}/oauth/validate
  UNMATCHED_VERIFY_CODE: '인증번호가 일치하지 않습니다. 다시 확인해주세요.', // 4050
  RESEND_TIME_LIMIT: '최근 1분 안에 같은 번호로 발송된 인증 문자가 있어요.\n잠시 후 다시 시도해 주세요.', // 4053
  TIMEOUT_VERIFY_CODE: '인증번호 입력 시간이 초과되었습니다. 다시 확인해주세요.', // 4051
  INVALID_AUTH_CODE: '인증번호가 일치하지 않습니다. 다시 확인해주세요.', // 4052
  EXCEED_LIMIT: '하루 최대 10회까지 전송할 수 있어요.', // 4054
  INVALID_TOKEN: '일시적인 문제가 발생했어요. 잠시 후 다시 시도해 주세요.', // 4055
  RESEND_COUNT_LIMIT: '다시 전송할 수 없어요.\n 처음부터 다시 시작해주세요.', // 4056
  VERIFY_COUNT_LIMIT: '입력 횟수가 초과되었습니다.', // 4057
  INVALID_REQUEST_PARAM: '모든 정보를 알맞게 입력했는지 한 번 더 확인해주세요.',
  INVALID_REQUEST_BODY: '모든 정보를 알맞게 입력했는지 한 번 더 확인해주세요.',
  INTERNAL_SERVER_ERROR: '일시적으로 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.'
}

export const NAME_ERROR_MESSAGE = '사용할 수 없는 문자가 포함되어 있습니다.'
export const PHONE_NUMBER_FORMAT_ERROR = '잘못된 휴대폰 번호입니다. 다시 확인해주세요.'

export const CONNECT_CONSENT_MESSAGE: ConnectConsentMessageType = {
  FMNX: {
    text: '음악 재생을 위해\n지금 바로 연결해 볼까요?',
    subText: '음악 90곡 무료 재생 혜택을 이용하려면 FLO 서비스 연결에 동의해주세요.',
    domain: 'FLO',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_flo.svg',
    clickId: 'fmnx'
  },
  JVTF: {
    text: '콘텐츠 재생을 위해\n지금 바로 연결해 볼까요?',
    subText: '원하는 영화와 VOD 재생을 위해 Wavve 서비스 연결에 동의해주세요.',
    domain: 'Wavve',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_wavve.svg',
    clickId: 'jvtf'
  },
  TWDT: {
    text: 'T world 이용을 위해\n지금 바로 연결해 볼까요?',
    subText: '남은 데이터와 요금을 조회하고 데이터 리필을 하실 수 있어요.',
    domain: 'T world',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_tworld.svg',
    clickId: 'twdt'
  },
  MBRS: {
    text: 'T 멤버십 이용을 위해\n지금 바로 연결해 볼까요?',
    subText: 'T 멤버십 할인혜택, 포인트 조회 등을 위해 T 멤버십 서비스 연결에 동의해주세요.',
    domain: 'T 멤버십',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_tmembership.svg',
    clickId: 'mbrs'
  },
  XZGA: {
    text: '온라인 최저가 득템을 위해\n지금 바로 연결해 볼까요?',
    subText: 'SK텔레콤 고객님을 위한 온라인 최저가 혜택을 받으려면 T deal 서비스 연결에 동의해주세요.',
    domain: 'T deal',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_tdeal.svg',
    clickId: 'xzga'
  },
  MELON: {
    text: '음악 재생을 위해\n지금 바로 연결해 볼까요?',
    subText: '음악 90곡 무료 재생 혜택을 이용하려면 FLO 서비스 연결에 동의해주세요.',
    domain: '멜론',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_melon.svg',
    clickId: 'melon'
  }
}

export const USE_CONSENT_MESSAGE: UseConsentMessageType = {
  ADCANO: {
    text: '한눈에 보는 통화 지금 시작해 보세요',
    subText: '통화 녹음·요약·검색 등을 위해 통화요약 이용 약관에 동의해 주세요.',
    domain: '통화요약',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_callnote.svg',
    groupCode: 'G_CALL_NOTE',
    clickId: 'brief'
  },
  ADPHTO: {
    text: '나만의 AI 프로필 무료로 만들어 봐요',
    subText: '',
    domain: '프로필',
    imageUrl:
      'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon-square-rounded-tmembership.svg',
    groupCode: 'G_PHOTO',
    clickId: 'adphto'
  },
  ADSLEEP: {
    text: '수면 패턴을 이해하고, 건강한 수면 습관을 만들어요.',
    subText: '수면 분석을 위해 이용 약관에 동의해 주세요.',
    domain: '수면 분석',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_sleep.svg',
    groupCode: 'G_SLEEP_ANALYSIS',
    clickId: 'adsleep'
  },
  MVTKT: {
    text: '',
    subText: '',
    domain: 'T 멤버십 무비',
    imageUrl: 'https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/common/icon_service_tmovie.svg',
    groupCode: 'G_CONNECT_MOVIE',
    clickId: 'mvtkt'
  },
  OVTD: {
    text: '',
    subText: '',
    domain: '에이닷',
    imageUrl: '',
    groupCode: 'G_JOIN',
    clickId: ''
  }
}

export const SIGN_UP_MESSAGE: { [key: string]: string } = {
  NAME: '이름을 입력해 주세요',
  BIRTHDAY: '주민등록번호\n앞 7자리를 입력해 주세요',
  TELECOM: '통신사를\n선택해 주세요',
  PHONENUMBER: '휴대폰 번호를\n입력해 주세요',
  SMSCODE: '아래 정보로\n본인인증을 진행합니다',
  TERMS: '필수 약관에 동의해 주세요',
  VERIFYCODE: '문자 메세지를\n확인해 주세요'
}

export const TELECOM_TYPE = ['SKT', 'KT', 'LGU', 'SKTM', 'KTM', 'LGUM']

export const SIGN_UP_VALIDATE = {
  NUMBER: /^[0-9]$/,
  NUMBER_EXCEPT: /[^0-9]$/g, // NUMBER 외의 문자를 매칭. (for replace)
  NAME: /^\s*(?:[a-zA-Z]+(?:\s[a-zA-Z]+)*|[가-힣]+)\s*$/, // 아래 설명 참고
  NAME_INPUT: /^[ㄱ-ㅎ가-힣A-Za-zㆍᆞᆢ\s]+$/,
  NAME_INPUT_EXCEPT: /[^ㄱ-ㅎ가-힣A-Za-zㆍᆞᆢ\s]/g // NAME_INPUT 외의 문자를 매칭. (for replace)
}

export const enum SEND_PERFORMANCE_TYPE {
  START = 'start',
  STOP = 'stop',
  CANCEL = 'cancel'
}

/*
 * SIGN_UP_VALIDATE.NAME에 대한 설명
 * - 영어 이름과 한글 이름을 구분.
 * - 영어 이름은 단어 사이에 공백이 허용되지만, 한글 이름에는 공백이 허용되지 않음.
 * - 문자열 앞이나 뒤에 공백은 허용. ( 앞뒤 공백은 서버에 최종 요청시 trim하여 제거됨 )
 * - 전체가 공백만 있는 경우는 false를 반환.
 */
